function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 13 13"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.5 13a6.5 6.5 0 110-13 6.5 6.5 0 010 13zM4.98 4.763c.396-.8.914-1.152 1.637-1.152.857 0 1.327.623 1.327 1.444.006.655-.578 1.385-1.873 2.159a.722.722 0 10.741 1.24C8.502 7.444 9.4 6.32 9.39 5.049c0-1.539-1.015-2.882-2.772-2.882-1.297 0-2.301.683-2.931 1.955a.722.722 0 101.295.641zm1.52 6.07a.722.722 0 100-1.444.722.722 0 000 1.444z"
}));